import { useState, useEffect } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import {
  addBaseOffer,
  getCategoryList,
  getProductTypeList,
} from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  containsNumber,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import { validateIsNumberOnlyErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ToggleSwitchButton from "../../../Component/toggleSwitchButton";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const CreateBaseOffer = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [discount, setDiscount] = useState<any>("");
  const [toggle, setToggle] = useState<any>(false);
  const [productTypeToggle, setProductTypeToggle] = useState<any>(false);
  const [categoryTypeToggle, setCategoryTypeToggle] = useState<any>(false);


  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);
  const onchangeProductType = (value: any) => {
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
    setProductType(value);
  };

  const onchangeCategory = (value: any) => {
    setCategory(value);
  };

  const onchangeDiscount = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setDiscount(value);
      }
    } else {
      setDiscount(value);
    }
  };

  const changeToggle = (event: any, key: string) => {
    if (event.target.checked && key === 'global') {
      setToggle(true);
      setProductTypeToggle(false);
      setCategoryTypeToggle(false);
    } else if (event.target.checked && key === 'productType') {
      setProductTypeToggle(true);
      setCategoryTypeToggle(false);
      setToggle(false);
    } else if (event.target.checked && key === 'categoryType') {
      setCategoryTypeToggle(true);
      setProductTypeToggle(false);
      setToggle(false);
    } else {
      setToggle(false);
      setProductTypeToggle(false);
      setCategoryTypeToggle(false);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData: any = {
      discPer: discount,
    };
    if (toggle) {
      postData["global"] = toggle
    }
    if (productType?._id) {
      postData["productType"] = productType?._id
    }
    if (category?._id) {
      postData["categoryId"] = category?._id
    }
    dispatch(
      addBaseOffer({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setProductType("");
            setCategory("");
            setDiscount("");
            setToggle(false);
            setCategoryTypeToggle(false);
            setProductTypeToggle(false);
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const validations = () => {
    return (
      (toggle && discount === "") ||
      (productTypeToggle && !productType?.name) ||
      (categoryTypeToggle &&
        (
          !productType?.name ||
          !category?.name ||
          discount === ""
        )
      )
    );
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Base Offer"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow py-4 borderRadius mb-4 editMode">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-5">
                <div className="col-md-12 mb-3 d-flex">
                  <LabelInput labelName={"Global Base Offer"} />
                  <div className="col-md-6 ms-auto">
                    <ToggleSwitchButton isActive={toggle}
                      getToggleval={(value: any) => {
                        changeToggle(value, "global");
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 mb-3 d-flex">
                  <LabelInput labelName={"Product Type Base Offer"} />
                  <div className="col-md-6 ms-auto">
                    <ToggleSwitchButton isActive={productTypeToggle}
                      getToggleval={(value: any) => {
                        changeToggle(value, "productType");
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 mb-3 d-flex">
                  <LabelInput labelName={"Category Type Base Offer"} />
                  <div className="col-md-6 ms-auto">
                    <ToggleSwitchButton isActive={categoryTypeToggle}
                      getToggleval={(value: any) => {
                        changeToggle(value, "categoryType");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                {toggle === true && !productTypeToggle && !categoryTypeToggle ? null : !toggle && (productTypeToggle || categoryTypeToggle) ?
                  <div className="col-md-10 mb-3">
                    <LabelInput labelName={"Product type"} />
                    <DropdownWithClear
                      labelName={"Select Product type"}
                      setInputText={(value: any) => onchangeProductType(value)}
                      options={productTypeList}
                      value={productType}
                    />
                  </div> : null}
                {toggle === true && !productTypeToggle && !categoryTypeToggle ? null : !toggle && !productTypeToggle && categoryTypeToggle ?
                  <div className="col-md-10 mb-3">
                    <LabelInput labelName={"Product category "} />
                    <DropdownWithClear
                      labelName={"Select Product category "}
                      setInputText={(value: any) => onchangeCategory(value)}
                      options={categoryList}
                      value={category}
                    />
                  </div>
                  : null}
                {(toggle || productTypeToggle || categoryTypeToggle) && (
                  <>
                    <div className="col-md-10 mb-3">
                      <LabelInput labelName={"Discount Value(%)"} isRequired />
                      <InputField
                        key={"ex2"}
                        placeholder={"Enter Discount Value Percent"}
                        setInputText={(value: any) => onchangeDiscount(value)}
                        value={discount}
                        maxLength={3}
                      />
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <div className="col-3 pt-2">
                        <Submitbtn name={"Submit"} disabled={validations()} />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
      </div >
    </div >
  );
};

export default CreateBaseOffer;
